// AddressInfoList.js
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/system';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import FlawedList from '../message/FlawedList';
import FlexyTable from '../common/flexytable/FlexyTable';
import ValueUtil from '../../model/ValueUtil';
import { AppWord, TableColumnType } from '../../model/AppConst';
import { AddressInfoDictionary } from './AddressInfoGql';
import { ContentHeader, HeaderLeft, HeaderRight } from '../common/CvoStyled';
import SearchBox from '../common/SearchBox';

const LocalTitle = '주소목록'; // ###################################

const AddressInfoListContainer = styled(Box)({
	flexGrow:1, display:'flex', flexDirection:'column'
});

/* const HeaderBox = styled(Box)({
    position: 'relative',
    height: AppNumber.HeaderToolBoxHeight,
    padding: AppNumber.SmallBoxPadding,
    '&>*': {verticalAlign: 'middle'}
});

const ButtonBox = styled(Box)({
    float:'right',
    display:'inline-block',
    '&>*': {marginLeft:10}
}); */

const Dict = AddressInfoDictionary.inputMap;
const TableColumns = [
    { id: 'fullname', label: Dict.fullname.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'addrGroupName', label: Dict.addrGroupId.label, width: 100, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'company', label: Dict.company.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'department', label: Dict.department.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'workRank', label: Dict.workRank.label, width: 80, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'job', label: Dict.job.label, width: 80, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'zipCode', label: Dict.zipCode.label, width: 80, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'address1', label: Dict.address1.label, width: 150, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    // { id: 'address2', label: Dict.address2.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'hpNo', label: Dict.hpNo.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'telNo', label: Dict.telNo.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'email', label: Dict.email.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'etc', label: Dict.etc.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    // { id: 'senderYn', label: Dict.senderYn.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'regDate', label: '등록일', width: 120, show: true, option:{align: 'inherit', type: TableColumnType.DATE} }
];

export default function AddressInfoList({
	maxHeight,
	maxWidth,
	selected,
    onClickItem,
    onRequestAdd,
    onRequestEdit,
    onRequestRemove,
    responseList,
    onRequestReload
}) {
    const [search, setSearch] = useState('');
    const [itemSelected, setItemSelected] = useState(selected);
    const {loading:loadingList, error:errorOfList, data:dataList} = responseList;

    const onChangeSearch = (text) => {
        setSearch(text);
    };

    const onClickToolOnRow = (toolId, row) => {
        switch(toolId) {
            case AppWord.CMD_REMOVE: onRequestRemove(row); break;
            case AppWord.CMD_EDIT: onRequestEdit(row); break;
            default: return;
        }
    };

    const onSelectItem = (item) => {
        setItemSelected(item);
		if(onClickItem) onClickItem(item);
    };

    // Handling list event
    if(ValueUtil.flawedListResponse(responseList))
        return <FlawedList title={LocalTitle} gqlResponse={responseList} />;

    return(
        <AddressInfoListContainer>
            <ContentHeader>
                <HeaderLeft>
                    <SearchBox
                        value={search}
                        onChange={onChangeSearch}
                    />
                    {/* <TextField id="search" onChange={onChangeSearch}
                        value={search}
                        label="검색" size={AppWord.SMALL}/> */}
                </HeaderLeft>
                <HeaderRight>
                    <Button
                        onClick={onRequestAdd}
                        variant='contained' color='primary'>
                        <AddIcon fontSize={AppWord.SMALL} /> 주소추가
                    </Button>
                </HeaderRight>
            </ContentHeader>
            <FlexyTable
                name="address_info_list"
                uniqueKey="addressId"
                columns={TableColumns}
                records={dataList.addressInfoList}
                search={search}
                tools={[
                    {id:AppWord.CMD_EDIT, icon:<NoteAltIcon fontSize={AppWord.SMALL} />},
                    {id:AppWord.CMD_REMOVE, icon: <DeleteForeverIcon fontSize={AppWord.SMALL} />}
                ]}
                onClickTool={onClickToolOnRow}
                onClickOneRow={onSelectItem}
				selected={selected ? [selected] : null}
                onRequestReload={onRequestReload}
                defaultSorter={{id:'fullname', type: TableColumnType.TEXT}}
            />
        </AddressInfoListContainer>
    );

}
